import axios from "axios";

import {
  reducerRolesRights,
  reducerRoles,
  reducerRolesStatus
} from "../../reducer/accessRights/reducers/roles";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetRoles = () => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  try {
    const response = await axios.get(`${BASE_URL}/json/auth/roles`);
    dispatch(reducerRoles(response.data));
  } catch (e: any) {
    if (e.response.status === 401) {
      window.location.href = "/login";
    }
  }
};

export const actionGetRolesRights =
  (id: number) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/auth/claim/role?id=${id}`
      );
  
      dispatch(reducerRolesRights(response.data)); 
    } catch {
      console.log('err');
    }
  };

export const actionDeleteRight =
  (id: number, data: { id: number, name: string }[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.delete(
        `${BASE_URL}/json/auth/claim/role?id=${id}`,
        { data }
      );

      dispatch(reducerRolesRights(response.data));
    } catch (e: any) {
      if (e.response.status === 403) {
        dispatch(reducerRolesStatus(0));
      }
    }
  };

export const actionAddRight =
  (id: number, data: { id: number, name: string }[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/auth/claim/role?id=${id}`, data
      );
      dispatch(reducerRolesRights(response.data));
    } catch (e: any) {
      if (e.response.status === 403) {
        dispatch(reducerRolesStatus(0));
      }
    }
  };

export const actionUpdateClaimDescription =
  (id: number, data: { description: string, role?: { id: number, name?: string }, claim?: {
    id: number },}) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    await axios.patch(`${BASE_URL}/json/auth/claim/description?id=${id}`, data);
    const response = await axios.patch(`${BASE_URL}/json/auth/claim/description?id=${id}`, data);

    dispatch(reducerRolesRights(response.data));
  };
